export const CONFLICT_ERROR_CODE = 'Value must be unique';
